import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'
import MenuIcon from '~/components/icons/ui/24px_menu-34.svg'
import RemoveIcon from '~/components/icons/ui/24px_simple-remove.svg'
import BackIcon from '~/components/icons/arrows/24px_minimal-left.svg'
import { useNavigate } from 'react-router'

const Wrapper = styled.div`
  display: none;

  @media (max-width: 870px) {
    display: flex;
    width: 100%;

    .button {
      display: flex;
      width: 20%;
      align-items: center;
      justify-content: center;

      button {
        background: none;
        border: none;
        cursor: pointer;
      }
    }

    .label {
      display: flex;
      width: 60%;
      align-items: center;
      justify-content: center;
    }
  }
`

export default function Head({
  title,
  isVisibleMenu,
  onToggleMenu,
  menu,
}: {
  title?: string
  isVisibleMenu: boolean
  onToggleMenu: any
  menu: boolean
}) {
  const navigate = useNavigate()

  const handleGoBackList = (title?: string) => {
    if (title === 'Questionário') {
      navigate('/app/questionnaire/list', { replace: true })
    }
    navigate(-1)
  }

  // const handleGoBack = () => {
  //   navigate(-1)
  // }
  return (
    <Wrapper>
      <div className='button'>
        <button className='link' onClick={() => handleGoBackList(title)}>
          <BackIcon width={24} height={24} fill={colors.prixBlue} />
        </button>
      </div>

      {title ? (
        <div className='label'>
          <h3> {title} </h3>
        </div>
      ) : null}

      {menu ? (
        <div className='button'>
          <button className='link' onClick={() => onToggleMenu()}>
            {isVisibleMenu ? (
              <RemoveIcon width={24} height={24} fill={colors.prixBlue} />
            ) : (
              <MenuIcon width={24} height={24} fill={colors.prixBlue} />
            )}
          </button>
        </div>
      ) : null}
    </Wrapper>
  )
}
